// extracted by mini-css-extract-plugin
module.exports = {"button":"Scroll_button__7jqIE","visible":"Scroll_visible__Kjg0g","fade-in":"Scroll_fade-in__5nK0b","invisible":"Scroll_invisible__U7jfy","fade-out":"Scroll_fade-out__tZCAg"};